import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { addClient } from "../../../store/actions"
import OtherDropdowns from "components/dropdowns/Other/OtherDropdowns"
import SaveButton from "components/buttons/save"
import RsLink from "components/buttons/rsLink"
import { Row, Col, FormGroup, Label, ButtonGroup, Button, InputGroup } from "reactstrap"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import moment from "moment"
import PhoneInputField from "components/dropdowns/PhoneInputField"
import SafeField from "helpers/SafeField";
class ClientCreate extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleSubmitClient = this.handleSubmitClient.bind(this);
  }

  handleSubmitClient(values) {
    const payload = {
      agentId: parseInt(localStorage.getItem("userId")),
      userLogin: values.userLogin,
      title: values.title,
      firstName: values.firstName,
      lastName: values.lastName,
      prefferedEmail: values.email,
      clientStatusId: 0,
      clientPropertyTypeId: 0,
      clientTypeId: 0,
      clientSourceId: 0,
      isActive: true,
      fullAddress: values.fullAddress,
      addressLine1: values.addressLine1,
      addressLine2: values.addressLine2,
      nearestIntersection: values.city,
      city: values.city,
      province: values.province,
      postal: values.postal,
      country: values.country,
      longitude: values.longitude,
      latitude: values.latitude,
      contactFName: values.firstName,
      contactLName: values.lastName,
      phone: values.phone,
      phoneExt: values.phoneExt,
      email: values.email,
      mobile: values.mobile,
      isBuyer: (values.isBuyer) ? true : false,
      isSeller: (values.isSeller) ? true : false,
      isInvestor: (values.isInvestor) ? true : false,
      buyerType: values.buyerType ? parseInt(values.buyerType) : 0,
      sellerType: values.sellerType ? parseInt(values.sellerType) : 0,
      lastAgreementDate: moment(values.lastAgreementDate).format("YYYY-MM-DD"),
      sellerLastAgreementDate: moment(values.sellerLastAgreementDate).format("YYYY-MM-DD"),
      investorLastAgreementDate: moment(values.investorLastAgreementDate).format("YYYY-MM-DD"),
      buyerStartDate: values.buyerStartDate ? moment(values.buyerStartDate).format("YYYY-MM-DD") : null,
      buyerEndDate: values.buyerEndDate ? moment(values.buyerEndDate).format("YYYY-MM-DD") : null,
      sellerStartDate: values.sellerStartDate ? moment(values.sellerStartDate).format("YYYY-MM-DD") : null,
      sellerEndDate: values.sellerEndDate ? moment(values.sellerEndDate).format("YYYY-MM-DD") : null,
      commissionTypeId: values.commissionTypeId ? parseInt(values.commissionTypeId) : 0,
      commissionValue: values.commissionValue ? parseFloat(values.commissionValue) : 0,
      sellerCommissionTypeId: values.sellerCommissionTypeId ? parseInt(values.sellerCommissionTypeId) : 0,
      sellerCommissionValue: values.sellerCommissionValue ? parseFloat(values.sellerCommissionValue) : 0,

    }
      this.props.addClient(payload , (status) => {
        if (status=== true) {          
          this.props.toggleAddNew();
        }       
      });
  }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };
  render() {
    const { toggleAddNew } = this.props;
    return (
      <React.Fragment>

        <Formik
          enableReinitialize={true}
          initialValues={{
           
            firstName: (this.state && this.state.firstName) || "",
            lastName: (this.state && this.state.lastName) || "",
            email: (this.state && this.state.email) || "",
            mobile: (this.state && this.state.mobile) || "",

            lastAgreementDate: new Date(),
            CommissionTypeId: '',
            commissionValue: '',
            sellerCommissionTypeId: '',
            sellerCommissionValue: '',
            startDate:null,
            endDate:null,
            sellerStartDate:null,
            sellerEndDate:null,
            buyerType: '',
            sellerType: '',
            sellerLastAgreementDate: new Date(),
            investorLastAgreementDate: new Date(),
            userLogin:'',
            userLoginC:'',
            isBuyer:false,
            isSeller: false,
            isInvestor: false,
            skipLoginCreation: false

          }}
          validationSchema={Yup.object().shape({
          
            firstName: Yup.string().required(
              "This is required"
            ),
            lastName: Yup.string().required(
              "This is required"
            ),
            skipLoginCreation: Yup.boolean(),
            userLogin: Yup.string().when("skipLoginCreation", {
              is: false,
              then: (schema) =>
                schema
                  .email("Invalid email format")
                  .required("Email is required"),
              otherwise: (schema) => schema.notRequired().nullable(),
            }),

            userLoginC: Yup.string().when("skipLoginCreation", {
              is: false,
              then: (schema) =>
                schema
                  .email("Invalid email format")
                  .oneOf([Yup.ref("userLogin"), null], "Emails must match")
                  .required("Please confirm your email"),
              otherwise: (schema) => schema.notRequired().nullable(),
            }),

            email: Yup.string().email("Must be a valid Email")
              .max(255)
              .required("Email is required"),
            mobile: Yup.string().required("Email is required"),
            isBuyer: Yup.boolean(),
                               isSeller: Yup.boolean(),
                               isInvestor: Yup.boolean(),
                               buyerType: Yup.string().when("isBuyer", {
                                 is: true,
                                 then: Yup.string().required("Buyer type is required"),
                                 otherwise: Yup.string().nullable(),
                               }),
                               commissionTypeId: Yup.string().when("isBuyer", {
                                 is: true,
                                 then: Yup.string().required("Commission type is required"),
                                 otherwise: Yup.string().nullable(),
                               }),
                               commissionValue: Yup.number().when("isBuyer", {
                                 is: true,
                                 then: Yup.number()
                                   .typeError("Commission value must be a number")
                                   .required("Commission value is required"),
                                 otherwise: Yup.number().nullable(),
                               }),
                               buyerStartDate: Yup.date().nullable().when("buyerType", {
                                 is: "1",
                                 then: Yup.date().nullable().required("Start Date is required"),
                               }),
                               buyerEndDate: Yup.date().nullable().when("buyerType", {
                                 is: "1",
                                 then: Yup.date().nullable().required("End Date is required"),
                               }),
                               sellerType: Yup.string().when("isSeller", {
                                 is: true,
                                 then: Yup.string().required("Seller type is required"),
                                 otherwise: Yup.string().nullable(),
                               }),
                               sellerCommissionTypeId: Yup.string().when("isSeller", {
                                 is: true,
                                 then: Yup.string().required("Commission type is required"),
                                 otherwise: Yup.string().nullable(),
                               }),
                               sellerCommissionValue: Yup.number().when("isSeller", {
                                 is: true,
                                 then: Yup.number()
                                   .typeError("Commission value must be a number")
                                   .required("Commission value is required"),
                                 otherwise: Yup.number().nullable(),
                               }),
                                sellerStartDate: Yup.date().nullable().when("sellerType", {
                                 is: "2",
                                 then: Yup.date().nullable().required("Start Date is required"),
                               }),
                               sellerEndDate: Yup.date().nullable().when("sellerType", {
                                 is: "2",
                                 then: Yup.date().nullable().required("End Date is required"),
                               }),


          })}
          onSubmit={this.handleSubmitClient}

        >
          {({ errors, touched, handleChange, values, setFieldValue, setFieldTouched }) => (
            <Form
              className="needs-validation"
            >


              <Row>

                
                <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="firstName">
                      {this.props.t("First Name *")}
                    </Label>
                    <SafeField
                      name="firstName"
                      type="text"
                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.firstName && touched.firstName
                          ? " is-invalid"
                          : "")
                      }
                      id="firstName"
                    />
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

                <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="lastName">
                      {this.props.t("Last Name *")}
                    </Label>
                    <SafeField
                      name="lastName"
                      type="text"
                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.lastName && touched.lastName
                          ? " is-invalid"
                          : "")
                      }
                      id="lastName"
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <OtherDropdowns
                    name="maritalStatus"
                    label="Marital status"
                    fieldName="Lead:Marital Status"
                  />
                </Col>

                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="streetName">
                      {this.props.t("Address")}
                    </Label>


                    <PlacesAutocomplete
                      value={values.fullAddress}
                      onChange={(value) => setFieldValue('fullAddress', value)}
                      onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                    >
                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                          <input
                            {...getInputProps({
                              placeholder: 'Enter Address...',
                              className: 'form-control',

                            })}
                          />
                          <div className="">
                            {loading ? <div>Loading...</div> : null}

                            {suggestions.map((suggestion, i) => {
                              const className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                              const style = suggestion.active
                                ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                              return (
                                <div
                                  key={i}
                                  {...getSuggestionItemProps(suggestion, {
                                    style,
                                  })}
                                >
                                  {suggestion.description}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>

                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup className="mb-3">
                    <Label htmlFor="email">
                      {this.props.t("Email *")}
                    </Label>
                    <SafeField
                      name="email"
                      type="text"

                      onChange={handleChange}
                      className={
                        "form-control" +
                        (errors.email && touched.email
                          ? " is-invalid"
                          : "")
                      }
                      id="email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>

                <Col md="4">
                  <PhoneInputField
                  label="Mobile"
                  name="mobile"
                  value={values.mobile}
                  setFieldValue={setFieldValue}
                  error={errors.mobile}
                  touched={touched.mobile}
                  country="ca"
                  required={true}
                />
                 
                </Col>
                <Col md="4">
                 <PhoneInputField
                  label="Secondary Phone"
                  name="phone"
                  value={values.phone}
                  setFieldValue={setFieldValue}
                  error={errors.phone}
                  touched={touched.phone}
                  country="ca"
                  required={false}
                />
               
                </Col>
               

                <Col sm="12">
                  <h6 style={{ fontSize: 16 }} className="mb-3"><strong>Type Of Client</strong></h6>
                </Col>
                <Row>
                  <Col sm="12">
                    <div className="d-flex justify-content-between mb-1">
                      <div>
                        <Field
                          name="isBuyer"
                          className="form-check-input me-2 offcanvas-chk-box"
                          type="checkbox"
                          id="isBuyer"
                          onClick={e => handleChange(e)}
                        />
                        <Label
                          htmlFor="isBuyer"
                          className="form-check-label"
                        >
                          {this.props.t("Buyer")}
                        </Label>
                      </div>

                      {/* </FormGroup> */}
                    </div>
                  </Col>
                  {values.isBuyer && (
                    <Col sm="12">
                    <>
                                                   <label className="form-label rs-label-checkbox w-100">
                                                     <strong>Select Type *</strong>
                                                   </label>
                   
                                                   <div className="form-check form-check-inline rs-radio-check">
                                                     <SafeField
                                                       type="radio"
                                                       name="buyerType"
                                                       id="btnradio4"
                                                       value="1"
                                                       className="form-check-input"
                                                     />
                                                     <label className="form-check-label" htmlFor="btnradio4">
                                                       Rent
                                                     </label>
                                                   </div>
                   
                                                   <div className="form-check form-check-inline rs-radio-check">
                                                     <SafeField
                                                       type="radio"
                                                       name="buyerType"
                                                       id="btnradio5"
                                                       value="2"
                                                       className="form-check-input"
                                                     />
                                                     <label className="form-check-label" htmlFor="btnradio5">
                                                       Purchase
                                                     </label>
                                                   </div>
                   
                                                   <div style={{ height:10 }}></div>
                   
                                                   {/* ErrorMessage handles display automatically */}
                                                   <ErrorMessage
                                                     name="buyerType"
                                                     component="div"
                                                     className="text-danger"
                                                   />
                                                 </>
                    </Col>
                  )}
                </Row>

                {values.isBuyer && (
                  <>
                    <Row>
                      <Col sm="4">
                        <FormGroup className="mb-3">
                                <Label htmlFor="commissionTypeId">{this.props.t("Commission Type *")}</Label>
                                <SafeField as="select" name="commissionTypeId" id="commissionTypeId"
                                  className={`form-control ${errors.commissionTypeId && touched.commissionTypeId ? "is-invalid" : ""
                                    }`}
                                >
                                  <option value="">Select</option>
                                  <option value="4">Percentage</option>
                                  <option value="3">Fixed</option>

                                </SafeField>
                                <ErrorMessage name="commissionTypeId" component="div" className="invalid-feedback" />
                              </FormGroup>
                      </Col>

                      <Col sm="4">
                       <FormGroup className="mb-3">
                                                       <Label htmlFor="commissionValue">{this.props.t("Commission Value *")}</Label>
                                                       <SafeField type="text" name="commissionValue"
                                                         className={`form-control ${errors.commissionValue && touched.commissionValue ? "is-invalid" : ""
                                                           }`}
                                                       />
                                                       <ErrorMessage name="commissionValue" component="div" className="invalid-feedback" />
                                                     </FormGroup>
                      </Col>

                      <Col sm="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="lastAgreementDate">
                            {this.props.t("Agreement Date *")}
                          </Label>
                          <InputGroup>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.lastAgreementDate && touched.lastAgreementDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.lastAgreementDate}
                              onChange={value =>
                                setFieldValue("lastAgreementDate", value[0])
                              }
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                              }}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <i className="mdi mdi-clock-outline" />
                              </span>
                            </div>
                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                    {values.buyerType == 1 && (
                     <Row>
                                                  <Col sm="6">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="startDate">
                                                        {this.props.t("Tentative start date *")}
                                                      </Label>
                                                      <InputGroup>
                                                        <Flatpickr
                                                          className={
                                                            "form-control" +
                                                            (errors.buyerStartDate && touched.buyerStartDate ? " is-invalid" : "")
                                                          }
                                                          placeholder=""
                                                          value={values.buyerStartDate}
                                                          onChange={value => {
                                                            setFieldValue("buyerStartDate", value[0]);
                                                            setFieldTouched("buyerStartDate", true);
                                                          }}
                                                          options={{
                                                            altInput: false,
                                                            altFormat: "F j, Y",
                                                            dateFormat: "Y-m-d",
                                                          }}
                                                        />
                                                        <div className="input-group-append">
                                                          <span className="input-group-text">
                                                            <i className="mdi mdi-clock-outline" />
                                                          </span>
                                                        </div>
                                                        <ErrorMessage name="buyerStartDate" component="div" className="invalid-feedback" />
                                                      </InputGroup>
                    
                                                    </FormGroup>
                                                  </Col>
                                                  <Col sm="6">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="buyerEndDate">
                                                        {this.props.t("Tentative End date *")}
                                                      </Label>
                                                      <InputGroup>
                                                        <Flatpickr
                                                          className={
                                                            "form-control" +
                                                            (errors.buyerEndDate && touched.buyerEndDate
                                                              ? " is-invalid"
                                                              : "")
                                                          }
                                                          placeholder=""
                                                          value=""
                                                          onChange={value => {
                                                            setFieldValue("buyerEndDate", value[0]);
                                                            setFieldTouched("buyerEndDate", true);
                                                          }}
                    
                                                          options={{
                                                            altInput: false,
                                                            altFormat: "F j, Y",
                                                            dateFormat: "Y-m-d",
                                                          }}
                                                        />
                                                        <div className="input-group-append">
                                                          <span className="input-group-text">
                                                            <i className="mdi mdi-clock-outline" />
                                                          </span>
                                                        </div>
                                                        <ErrorMessage name="endDate" component="div" className="invalid-feedback" />
                                                      </InputGroup>
                    
                                                    </FormGroup>
                                                  </Col>
                                                </Row>
                    )}
                  </>
                )}

                <Row>
                  <Col sm="12">
                    <div className="d-flex justify-content-between mb-1">
                      <div>
                        <Field
                          name="isSeller"
                          className="form-check-input me-2 offcanvas-chk-box"
                          type="checkbox"
                          id="isSeller"
                          onClick={e => handleChange(e)}
                        // checked='true'
                        />
                        <Label
                          htmlFor="isSeller"
                          className="form-check-label"
                        >
                          {this.props.t("Seller")}
                        </Label>
                      </div>

                      {/* </FormGroup> */}
                    </div>
                  </Col>
                 <Col sm="12">
                                           <div className="" style={{ marginTop: 10 }}>
                                             {values.isSeller && (
                                               <>
                                                 <label className="form-label rs-label-checkbox w-100"><strong>Select Type *</strong></label>
                                                   
                                                 <div className="form-check form-check-inline rs-radio-check">
                                                   <Field
                                                     type="radio"
                                                     name="sellerType"
                                                     id="btnradio6"
                                                     value="1"
                                                     className="form-check-input"
                                                   />
                                                   <label className="form-check-label" htmlFor="btnradio6">
                                                     Sell
                                                   </label>
                                                 </div>
                 
                                                 <div className="form-check form-check-inline rs-radio-check">
                                                   <Field
                                                     type="radio"
                                                     name="sellerType"
                                                     id="btnradio7"
                                                     value="2"
                                                     className="form-check-input"
                                                   />
                                                   <label className="form-check-label" htmlFor="btnradio7">
                                                     Lease
                                                   </label>
                                                 </div>
                 
                                                 <div style={{ height:10 }}></div>
                 
                                                 {/* ErrorMessage handles display automatically */}
                                                 <ErrorMessage
                                                   name="sellerType"
                                                   component="div"
                                                   className="text-danger"
                                                 />
                                     
                                               </>
                                             )}
                                            
                                           </div>
                                         </Col>
                </Row>

                {values.isSeller && (
                  <>
                                           <Row>
                                             <Col sm="4">
                                               <FormGroup className="mb-3">
                                                 <Label htmlFor="sellerCommissionTypeId">{this.props.t("Commission Type *")}</Label>
                                                 <SafeField as="select" name="sellerCommissionTypeId" 
                                                  className={`form-control ${errors.sellerCommissionTypeId && touched.sellerCommissionTypeId ? "is-invalid" : ""
                                                     }`}
                                                 >
                                                   <option value="">Select</option>
                                                   <option value="4">Percentage</option>
                                                   <option value="3">Fixed</option>
                 
                                                 </SafeField>
                                                 <ErrorMessage name="sellerCommissionTypeId" component="div" className="invalid-feedback" />
                                               </FormGroup>
                                             </Col>
                 
                                             <Col sm="3">
                                               <FormGroup className="mb-3">
                                                 <Label htmlFor="sellerCommissionValue">{this.props.t("Commission Value *")}</Label>
                                                 <SafeField type="text" name="sellerCommissionValue" 
                                                   className={`form-control ${errors.sellerCommissionValue && touched.sellerCommissionValue ? "is-invalid" : ""
                                                     }`}
                                                 />
                                                 <ErrorMessage name="sellerCommissionValue" component="div" className="invalid-feedback" />
                                               </FormGroup>
                                             </Col>
                 
                                             <Col sm="5">
                                               <FormGroup className="mb-3">
                                                 <Label htmlFor="sellerLastAgreementDate">
                                                   {this.props.t("Agreement Date *")}
                                                 </Label>
                                                 <InputGroup>
                                                   <Flatpickr
                                                     className={
                                                       "form-control" +
                                                       (errors.sellerLastAgreementDate && touched.sellerLastAgreementDate
                                                         ? " is-invalid"
                                                         : "")
                                                     }
                                                     placeholder=""
                                                     value={values.sellerLastAgreementDate}
                                                     onChange={value =>
                                                       setFieldValue("sellerLastAgreementDate", value[0])
                                                     }
                                                     options={{
                                                       altInput: true,
                                                       altFormat: "F j, Y",
                                                       dateFormat: "Y-m-d",
                                                     }}
                                                   />
                                                   <div className="input-group-append">
                                                     <span className="input-group-text">
                                                       <i className="mdi mdi-clock-outline" />
                                                     </span>
                                                   </div>
                                                 </InputGroup>
                                               </FormGroup>
                                             </Col>
                                           </Row>
                 
                                           {values.sellerType == 2 && (
                                             <Row>
                                               <Col sm="6">
                                                 <FormGroup className="mb-3">
                                                   <Label htmlFor="sellerStartDate">
                                                     {this.props.t("Tentative start date *")}
                                                   </Label>
                                                   <InputGroup>
                                                     <Flatpickr
                                                       className={
                                                         "form-control" +
                                                         (errors.sellerStartDate && touched.sellerStartDate
                                                           ? " is-invalid"
                                                           : "")
                                                       }
                                                       placeholder=""
                                                       value=""
                                                       onChange={value => {
                                                         setFieldValue("sellerStartDate", value[0]);
                                                         setFieldTouched("sellerStartDate", true);
                                                       }}
                                                       options={{
                                                         altInput: false,
                                                         altFormat: "F j, Y",
                                                         dateFormat: "Y-m-d",
                                                       }}
                                                     />
                                                     <div className="input-group-append">
                                                       <span className="input-group-text">
                                                         <i className="mdi mdi-clock-outline" />
                                                       </span>
                                                     </div>
                                                   </InputGroup>
                                                    <ErrorMessage name="sellerStartDate" component="div" className="invalid-feedback" />
                                                 </FormGroup>
                                               </Col>
                                               <Col sm="6">
                                                 <FormGroup className="mb-3">
                                                   <Label htmlFor="sellerEndDate">
                                                     {this.props.t("Tentative End date *")}
                                                   </Label>
                                                   <InputGroup>
                                                     <Flatpickr
                                                       className={
                                                         "form-control" +
                                                         (errors.sellerEndDate && touched.sellerEndDate
                                                           ? " is-invalid"
                                                           : "")
                                                       }
                                                       placeholder=""
                                                       value=""
                                                        onChange={value => {
                                                         setFieldValue("sellerEndDate", value[0]);
                                                         setFieldTouched("sellerEndDate", true);
                                                       }}
                                                       options={{
                                                         altInput: false,
                                                         altFormat: "F j, Y",
                                                         dateFormat: "Y-m-d",
                                                       }}
                                                     />
                                                     <div className="input-group-append">
                                                       <span className="input-group-text">
                                                         <i className="mdi mdi-clock-outline" />
                                                       </span>
                                                     </div>
                                                   </InputGroup>
                                                    <ErrorMessage name="sellerEndDate" component="div" className="invalid-feedback" />
                                                 </FormGroup>
                                               </Col>
                                             </Row>
                 
                                           )}
                                         </>
                )}


                <FormGroup className="mb-3">
                  <Field
                    name="isInvestor"
                    className="form-check-input me-2 offcanvas-chk-box"
                    type="checkbox"
                    id="isInvestor"
                    onClick={e => handleChange(e)}
                  // checked='true'
                  />
                  <Label
                    htmlFor="isInvestor"
                    className="form-check-label"
                  >
                    {this.props.t("Investor")}
                  </Label>
                </FormGroup>
                {values.isInvestor && (
                  <Row>


                    <Col sm="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="investorLastAgreementDate">
                          {this.props.t("Agreement Date *")}
                        </Label>
                        <InputGroup>
                          <Flatpickr
                            className={
                              "form-control" +
                              (errors.investorLastAgreementDate && touched.investorLastAgreementDate
                                ? " is-invalid"
                                : "")
                            }
                            placeholder=""
                            value={values.investorLastAgreementDate}
                            onChange={value =>
                              setFieldValue("investorLastAgreementDate", value[0])
                            }
                            options={{
                              altInput: true,
                              altFormat: "F j, Y",
                              dateFormat: "Y-m-d",
                            }}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">
                              <i className="mdi mdi-clock-outline" />
                            </span>
                          </div>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                <hr />
                 <Col sm="12">
                  <div className="form-check mb-3">
                      <Field
                        type="checkbox"
                        name="skipLoginCreation"
                        className="form-check-input offcanvas-chk-box me-2"
                        id="skipLoginCreation"
                      />
                      <label
                        htmlFor="skipLoginCreation"
                        className="form-check-label form-label"
                      >
                        Skip login creation
                      </label>
                      <ErrorMessage
                        name="skipLoginCreation"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                </Col>
               
                {values.skipLoginCreation==false && (
                  <>
                   <Col sm="12">
                  <h6 style={{ fontSize: 16 }} className="mb-3"><strong>Client Login Info</strong></h6>
                </Col>
                <div className="row">
                  <div className="col-md-4 col-form-label"><strong>Login email (cannot be changed) *</strong></div>
                  <div className="col-md-4">
                    <FormGroup className="mb-3">
                      <SafeField
                        name="userLogin"
                        type="text"

                        onChange={handleChange}
                        className={
                          "form-control" +
                          (errors.userLogin && touched.userLogin
                            ? " is-invalid"
                            : "")
                        }
                        id="userLogin"
                      />


                        <ErrorMessage name="userLogin" component="div" className="invalid-feedback" />
                    </FormGroup>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 col-form-label"><strong>Confirm email *</strong></div>
                  <div className="col-md-4">
                    <FormGroup className="mb-3">
                      <SafeField
                        name="userLoginC"
                        type="text"

                        onChange={handleChange}
                        className={
                          "form-control" +
                          (errors.userLoginC && touched.userLoginC
                            ? " is-invalid"
                            : "")
                        }
                        id="userLoginC"
                      />

                        <ErrorMessage name="userLoginC" component="div" className="invalid-feedback" />

                    </FormGroup>
                  </div>
                </div>
                <Col sm="12">
                        <h6>A system generated password is sent to the client</h6>
                </Col>
                </>
                )}
                
                {/* <Col sm="12">
                  <div className="form-check  form-check-success mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input client-check-box"
                      id="customCheckcolor5"
                    />
                    <label
                      className="form-check-label client-check-lebel"
                      htmlFor="customCheckcolor5"
                    >
                      Don`t Send Login email now
                    </label>
                  </div>
                </Col> */}
              </Row>
              <div><SaveButton>{this.props.t("Save")}</SaveButton>{" "} <RsLink onClick={toggleAddNew}>Close</RsLink></div>




            </Form>
          )}
        </Formik>

      </React.Fragment>
    )
  }
}

ClientCreate.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  error: PropTypes.any,
  addClient: PropTypes.func,
  toggleAddNew: PropTypes.object
}
const mapDispatchToProps = dispatch => ({
  addClient: (data, callback) => dispatch(addClient(data, callback)),
})
export default connect('', mapDispatchToProps)(withTranslation()(ClientCreate))
